import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdvisorList from './components/Pages/AdvisorList';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import CalculatorSection from './components/Pages/CalculatorSection';
import MainLayout from './components/Layouts/MainLayout';
import CalculatorEmbed from './components/Pages/CalculatorEmbed';
import Analytics from './Analytics';
import FAQPage from './components/Pages/FAQPage';


const App: React.FC = () => {
  return (
    <Router>
      <Analytics/>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<AdvisorList />} />
          <Route path="advisors" element={<AdvisorList />} />
          <Route path="calculators" element={<CalculatorSection />} />
          <Route path="calculators/retirement" element={<CalculatorEmbed file="Retirement-Planner.html" />} />
          <Route path="calculators/compounding" element={<CalculatorEmbed file="CompoundingPower.html" />} />
          <Route path="calculators/stepup" element={<CalculatorEmbed file="Step-up-SIP-calculator.html" />} />
          <Route path="calculators/early" element={<CalculatorEmbed file="Early-Investment-Calculator.html" />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
